import { createContext, useContext } from "react";

/** One direction of prev/next: a neighbour to step to, or the end of the list. */
export type MediaDetailStep =
  | { kind: "neighbour"; go: () => void }
  | { kind: "end" };

/** Prev/next through the list a detail view was opened from. */
export type MediaDetailNavigation =
  | { kind: "none" }
  | { kind: "list"; previous: MediaDetailStep; next: MediaDetailStep };

/** A close button in the header, or none: the dialog puts its own in a corner. */
export type MediaDetailClose =
  | { kind: "in-header"; onClose: () => void }
  | { kind: "none" };

export type MediaDetailControls = {
  navigation: MediaDetailNavigation;
  close: MediaDetailClose;
};

export const MediaDetailControlsContext = createContext<MediaDetailControls>({
  navigation: { kind: "none" },
  close: { kind: "none" },
});

export function useMediaDetailControls(): MediaDetailControls {
  return useContext(MediaDetailControlsContext);
}
